














































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import PasswordInput from '@/modules/shared/components/shared/form/PasswordInput.vue'
import { UserUpdateSettingRequestModel } from '@/modules/user/models/user-request.model'
import AdminRoleSearch from '@/modules/role/components/admin/AdminRoleSearch.vue'
import { AdminUserUpdateSettingUseCase } from '@/modules/user/use-cases/admin/admin-user-update-setting.use-case'
import { Prop } from 'vue-property-decorator'
import CurrencyInput from '@/modules/shared/components/shared/form/CurrencyInput.vue'
import { UserResourceInAdminModel } from '@/modules/user/models/user-resource.model'

@Component({
  components: {
    CurrencyInput,
    AdminRoleSearch,
    PasswordInput,
    BaseInput,
    BaseButton
  }
})
export default class AdminCreateUserForm extends Vue {
  constructor(private readonly useCase: AdminUserUpdateSettingUseCase) {
    super()
  }

  @Prop({ required: true }) userResource: UserResourceInAdminModel

  protected requestData: UserUpdateSettingRequestModel = {
    word_rate: this.userResource.word_rate ?? null,
    ai_word_rate: this.userResource.ai_word_rate ?? null
  }

  protected onSubmit() {
    this.useCase.execute(this.userResource.id, this.requestData).onSuccess(() => {
      this.$emit('success')
    })
  }
}
